/* eslint-disable no-nested-ternary */

// ### DOCUMENTATION ############################################################

// ### IMPORTS ##################################################################

// ### TYPES ####################################################################

// ### FUNCTIONS ################################################################

// ### COMPONENT ################################################################

// ### STYLES ###################################################################

import React from "react"
import { NavLink } from "react-router-dom"
import styled from "styled-components"
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
// ** Quand unxxxxxxxxxxxxxx
// ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

type Props = {
    className?: string
}

ButtonNavLinkRegister.defaultProps = { className: "" }
export function ButtonNavLinkRegister({ className }: Props) {
    return (
        <StyledButtonNavlink to="/auth/register" className={className}>
            Inscription
        </StyledButtonNavlink>
    )
}

ButtonNavLinkLogin.defaultProps = { className: "" }
export function ButtonNavLinkLogin({ className }: Props) {
    return (
        <StyledButtonNavlink to="/auth/login" className={className}>
            Connexion
        </StyledButtonNavlink>
    )
}

ButtonNavLinkPasswordForfotten.defaultProps = { className: "" }
export function ButtonNavLinkPasswordForfotten({ className }: Props) {
    return (
        <StyledButtonNavlink
            to="/auth/password_forgotten"
            className={className}
        >
            Mot de passe oublié ?
        </StyledButtonNavlink>
    )
}

// ***************************************************************

// 〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓〓	STYLED_COMPONENTS

const StyledButtonNavlink = styled(NavLink)``
